import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { sipApi } from "../../app/slices/sipSlice";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  LinearProgress,
} from "@mui/material";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import { IconButton, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material";

import { IoIosArrowRoundBack } from "react-icons/io";
import GoldSIP from "./GoldSIP";
import axios from "axios";
import { userApi } from "../../app/slices/userSlice";
import SipTables from "./SipTables";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import axiosInstance from "../../utils/axiosInstance";
import axiosInstanceMainUrl from "../../utils/axiosInstanceMainUrl";

export default function Sip() {
  const mainUrl = import.meta.env.VITE_MAIN_URL;
  const roleResponse = useSelector((state) => state.login.login.role);
  const [activeTab1, setActiveTab1] = useState("ACTIVE");
  // console.log("activeTab1: /////// ", activeTab1);

  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  useEffect(() => {
    const fetchData = async () => {
      const { startDate, endDate } = queryParams;
      try {
        await dispatch(
          sipApi({
            status: activeTab1,
            startDate,
            endDate,
          })
        ).unwrap();
      } catch (error) {
        console.error(`Failed to fetch data for ${activeTab1}:`, error);
      }
    };

    fetchData();
  }, [dispatch, activeTab1, queryParams]);
  // useEffect(() => {
  //   // dispatch(sipApi(queryParams));
  //   dispatch(sipApi({
  //     // status: "ACTIVE",
  //     status: "Initialized",

  //   }));
  // }, [dispatch, queryParams,activeTab1]);

  const sipSliceResponse = useSelector((state) => state.sip.sip.data);
  const stateLoading = useSelector(
    (state) => state.sip.loading
  );
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };

  const [activeTab, setActiveTab] = useState("Gold SIP");
  const [showForm, setShowForm] = useState(true);
  const formShowHandler = (e) => {
    e.preventDefault();
    setShowForm(false);
  };


  /////////////////////////////////////////////////// Gold and Silver Rates  //////////////////////
  const token = localStorage.getItem("token");


  const [goldPrice, setGoldPrice] = useState("");
  const [silverPrice, setSilverPrice] = useState("");
  const getGoldLive = async () => {
    try {
      const url = `/merchant/OnlineLiveRates`;
      // const url = `${mainUrl}/merchant/OnlineLiveRates`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axiosInstanceMainUrl.get(url);
      // const response = await axios.get(url, { headers });
      const liveValue = response.data.data;

      setGoldPrice(liveValue[0]["gBuy"]);
      setSilverPrice(liveValue[0]["sBuy"]);

    } catch (error) {
      console.error("Error connecting to API", error);
    }
  };
  useEffect(() => {
    getGoldLive()
  }, []);
  /////////////////////////////////////////////////// Gold and Silver Rates End  //////////////////////

  const [formErrors, setFormErrors] = useState({});

  /////////////////////////////////////////////////// User Selection  //////////////////////
  const [inputValue, setInputValue] = useState("");
  // console.log("inputValue: ", inputValue);
  const [userId, setuserId] = useState("");
  // console.log("userId: ", userId);
  const handleUserSelection = (user) => {
    setuserId(user);
    setFormErrors({})
  };
  useEffect(() => {
    dispatch(userApi());
  }, [dispatch]);

  const sliceResponse = useSelector((state) => state.user.user.data);

  /////////////////////////////////////////////////// User Selection End  //////////////////////




  const handleTabChange = (tab) => {
    setActiveTab1(tab);
    setQueryParams({
      startDate: null,
      endDate: null,
    });
  };

  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
  };




  const statusTabs = [
    { label: "Active", value: "ACTIVE" },
    { label: "Initialized", value: "Initialized" },
    { label: "Cancelled", value: "CANCELLED" },
    { label: "Link Expired", value: "LINK_EXPIRED" },
    { label: "Bank Approval Pending", value: "BANK_APPROVAL_PENDING" },
  ];

  return (
    <>
      {showForm && roleResponse?.Sip?.write === 1 && (
        <Grid item xs={12} md={6} lg={3} sx={{ mb: { xs: 2, sm: 4 } }}>
          <Button
            onClick={formShowHandler}
            variant="contained"
            sx={{
              backgroundColor: "#4a2a7d",
              color: "white !important",
              "&:hover": {
                backgroundColor: "#4a2a7d",
              },
            }}
          >
            Create SIP +
          </Button>
        </Grid>
      )}
      {!showForm && (
        <Card>
          <IconButton onClick={() => setShowForm(true)}>
            <IoIosArrowRoundBack />
          </IconButton>
          <CardContent sx={{ mb: 0 }}>
            <Box sx={{ mb: 0 }}>
              <Box>
                <Box display="flex" justifyContent="center" mb={2}>
                  <Button
                    variant={
                      activeTab === "Gold SIP"
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() => setActiveTab("Gold SIP")}
                    sx={{ marginRight: 1 }}
                  >
                    Gold SIP
                  </Button>
                  <Button
                    variant={
                      activeTab === "Silver SIP" ? "contained" : "outlined"
                    }
                    onClick={() => setActiveTab("Silver SIP")}
                  >
                    Silver SIP
                  </Button>
                </Box>

                {/* Conditionally render content based on activeTab */}
                {activeTab === "Gold SIP" && (
                  <div>
                    {roleResponse?.Sip?.write === 1 && (
                      <GoldSIP metalType="Gold" goldPrice={goldPrice} silverPrice={silverPrice} onUserSelect={handleUserSelection} inputValue={inputValue} setInputValue={setInputValue}
                        sliceResponse={sliceResponse} userId={userId} setuserId={setuserId} formErrors={formErrors} setFormErrors={setFormErrors} />
                    )}
                  </div>
                )}

                {activeTab === "Silver SIP" && (
                  <div>
                    {roleResponse?.Sip?.write === 1 && (
                      <GoldSIP metalType="Silver" goldPrice={goldPrice} silverPrice={silverPrice} onUserSelect={handleUserSelection} inputValue={inputValue} setInputValue={setInputValue}
                        sliceResponse={sliceResponse} userId={userId} setuserId={setuserId} formErrors={formErrors} setFormErrors={setFormErrors} />
                    )}
                    {/* render for Silver */}

                  </div>
                )}
              </Box>
            </Box>
          </CardContent>
        </Card>
      )}

     {/*  */}

      {showForm && (
        <>
          <Box display="flex" justifyContent={{ xs: "space-between", md: "center" }}
            alignItems="center"
            gap={{ xs: 0.5, md: 2 }}
            mb={2}
            sx={{
              width: "100%",
              flexWrap: "nowrap"
            }}> 
            {/* LEFT ARROW */}
            {/* <IconButton onClick={scrollLeft}>
              <ChevronLeftIcon />
            </IconButton> */}
            {/* SCROLLABLE CONTAINER */}
            <Box
              ref={scrollRef}
              sx={{
                display: "flex",
                gap: 1,
                overflowX: "auto",
                scrollBehavior: "smooth",
                whiteSpace: "nowrap",
                flex: 1,
                "&::-webkit-scrollbar": { display: "none" },
                scrollbarWidth: "none",
              }}
            >
              {statusTabs.map((tab) => (
                <Button
                  size="medium"
                  key={tab}
                  variant={activeTab1 === tab.value ? "contained" : "outlined"}
                  onClick={() => handleTabChange(tab.value)}
                  sx={{
                    minWidth: 120,
                    maxWidth: 160,
                    height: 40,
                    flexShrink: 0,
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    textAlign: "center",
                    lineHeight: 1.2,
                    fontSize: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {tab.label}
                </Button>
              ))}
              {/* RIGHT ARROW */}
              {/* <IconButton onClick={scrollRight}>
                <ChevronRightIcon />
              </IconButton> */}
            </Box>
          </Box>
          <DateSearchComponent onSearch={handleSearch} />

          {[
            "ACTIVE",
            "Initialized",
            "CANCELLED",
            "LINK_EXPIRED",
            "BANK_APPROVAL_PENDING",
          ].map(
            (tab) =>
              activeTab1 === tab &&
              (
                <Box mt={2} key={tab}> 
                  <SipTables sliceResponse={sipSliceResponse || []}
                    stateLoading={stateLoading}
                  />
                </Box>
              )
          )}
        </>
      )}
    </>
  );
}
